/**
 * Option to disable memoization. This should only be used under controlled circumstances and will result in worse runtime performance
 */

let memoizationDisabled = false;

export const isMemoizationDisabled = () => {
  return memoizationDisabled;
};

export const setMemoizationDisabled = (disabled: boolean) => {
  memoizationDisabled = disabled;
};
